import React from "react";

export default function PageNotFound() {
  return (
    <>
      <div className={`max-w-4xl h-screen mx-auto py-5`}>
        <h1 className="heading-text mb-4">Page Not Found</h1>
      </div>
    </>
  );
}
